import { api } from '@/api/client';
import type { PlatformConfig } from '@/types/platform';

/** Query keys are centralised so cache invalidation cannot drift from fetching. */
export const platformKeys = {
  bootstrap: ['platform', 'bootstrap'] as const,
};

/**
 * Loads brand tokens, feature flags, maintenance state, social links and
 * commerce defaults in a single request (§55 global system state).
 */
export function fetchPlatformConfig(): Promise<PlatformConfig> {
  return api.get<PlatformConfig>('/bootstrap');
}
